import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/themes/aurora.css";
import App from "@/App";

// Handle Supabase auth redirects with hash fragments before React loads
const handleRecoveryToken = () => {
  const hash = window.location.hash;
  const fullUrl = window.location.href;
  
  console.log('[Auth] Current URL:', fullUrl);
  console.log('[Auth] Hash:', hash);
  
  if (hash && hash.includes('type=recovery')) {
    const hashParams = hash.substring(1); // Remove the #
    const params = new URLSearchParams(hashParams);
    const accessToken = params.get('access_token');
    const type = params.get('type');
    
    console.log('[Auth] Recovery detected - token:', accessToken ? 'present' : 'missing');
    
    if (type === 'recovery' && accessToken) {
      // Store in both sessionStorage and localStorage for redundancy
      sessionStorage.setItem('supabase_recovery_token', accessToken);
      localStorage.setItem('supabase_recovery_token', accessToken);
      console.log('[Auth] Token stored successfully');
    }
  }
};

// Run before React mounts
handleRecoveryToken();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
